// extracted by mini-css-extract-plugin
export var actions = "_rl-4";
export var item = "_rl-1";
export var price = "_rl-3";
export var quantity = "_rl-2";
export var table = "_rl-0";